export default {
  resume: null,
  isLoadResumePreview: false,
  allResumes: [],
  allCoverLetters: [],
};
